module.exports = __webpack_public_path__ + "img/Groupe 514.6535a45e.svg";